import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiWind, FiCpu } = FiIcons;

const About = () => {
  return (
    <div className="pt-24 min-h-screen bg-metallic-light">
      <div className="max-w-[1200px] mx-auto px-6 py-12">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">Tentang Kami</h1>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Nusantara International Logistik memberikan layanan <strong>Fast, Safe, and Reliable Worldwide Delivery</strong>. Kami mengkhususkan diri dalam pengiriman internasional profesional untuk segala jenis kargo, mulai dari <em>General Cargo</em>, Alat Berat & Mesin Pertanian, Mesin Industri, hingga Kiriman Personal & Bisnis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
          <motion.div 
             initial={{ opacity: 0, x: -50 }}
             animate={{ opacity: 1, x: 0 }}
             className="relative rounded-2xl overflow-hidden shadow-2xl h-[400px]"
          >
            <img src="https://images.unsplash.com/photo-1553413077-190dd305871c?q=80&w=1000&auto=format&fit=crop" alt="Modern Warehouse" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-navy/20"></div>
          </motion.div>
          <motion.div
             initial={{ opacity: 0, x: 50 }}
             animate={{ opacity: 1, x: 0 }}
          >
            <h2 className="text-3xl font-bold text-navy mb-6">Visi Misi Berbasis ESG</h2>
            <p className="text-slate-600 mb-6 leading-relaxed">
              Kami menyadari dampak industri logistik terhadap lingkungan. Oleh karena itu, kami berkomitmen pada prinsip <strong>Keberlanjutan Ekosistem (ESG)</strong> melalui inisiatif "Green Logistics".
            </p>
            <ul className="space-y-4">
              <li className="flex items-start gap-4">
                <div className="bg-green-100 p-2 rounded-lg text-green-600 shrink-0"><SafeIcon icon={FiWind} /></div>
                <div>
                  <h4 className="font-semibold text-navy">Pengurangan Emisi Karbon</h4>
                  <p className="text-sm text-slate-500">Optimasi rute berbasis AI untuk meminimalisir jarak tempuh kosong dan konsumsi bahan bakar.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="bg-orange/10 p-2 rounded-lg text-orange shrink-0"><SafeIcon icon={FiCpu} /></div>
                <div>
                  <h4 className="font-semibold text-navy">Intelligent Logistics</h4>
                  <p className="text-sm text-slate-500">Adopsi teknologi prediktif untuk manajemen pergudangan dan pemeliharaan armada otomatis.</p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;